import './PortIndustryDetailPage.css'
import './PortProductListPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import PortBottomLayout from '../common/PortBottomLayout'
import { getIndustryByIid } from '../../products/ProductProvider'

export default class PortIndustryDetailPage extends React.Component {
  constructor(props) {
    super(props)
    const [iid, industry] = this.getIidAndIndustry(this.props.location.search)
    this.state = {
      iid: iid,
      industry: industry,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.location.search !== nextProps.location.search) {
      const [iid, industry] = this.getIidAndIndustry(nextProps.location.search)
      this.setState({
        iid: iid,
        industry: industry,
      })
      return true
    }
  }

  render() {
    return (
      <div>
        <div className="PortIndustryDetail">
          <div className="PortIndustryDetailHeader">
            <img
              className="PortIndustryDetailHeaderImage"
              src={this.state.industry.picture}
            />
            <div className="PortIndustryDetailHeaderTextWrapper">
              <div className="PortIndustryDetailHeaderTextContainer">
                <div className="PortIndustryDetailName">
                  {this.state.industry.title}
                </div>
                <div className="PortIndustryDetailIntroduction">
                  {this.state.industry.subtitle}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="PortIndustryDetailDocument">
          {this.state.industry.document.map((paragraph) => {
            return this.getParagraph(paragraph)
          })}
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }

  getParagraph = (paragraph) => {
    return (
      <div className={`PortIndustryDetailParagraph_${paragraph.style}`}>
        {paragraph.content}
      </div>
    )
  }

  getIidAndIndustry = (search) => {
    var i = search.indexOf('iid=')
    const iid = parseInt(search.substring(i + 4, search.length))
    const industry = getIndustryByIid(iid)
    return [iid, industry]
  }
}
